import { KbId } from '@/types';
import client from './client';

async function get() {
  const { data } = await client.get<KbId[]>(`/kbIds`);
  return data;
}

async function update({ id, kbId }: { id: string; kbId: string }) {
  const { data } = await client.patch<KbId>(`/kbIds/${id}`, {
    kbId,
  });
  return data;
}

export const kbIds = {
  get,
  update,
};
